/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";

export type RiskIDRequestBody = {
  /**
   * The resource ID.
   */
  id: string;
};

/** @internal */
export type RiskIDRequestBody$Outbound = {
  id: string;
};

/** @internal */
export const RiskIDRequestBody$outboundSchema: z.ZodMiniType<
  RiskIDRequestBody$Outbound,
  RiskIDRequestBody
> = z.object({
  id: z.string(),
});

export function riskIDRequestBodyToJSON(
  riskIDRequestBody: RiskIDRequestBody,
): string {
  return JSON.stringify(
    RiskIDRequestBody$outboundSchema.parse(riskIDRequestBody),
  );
}
